<script>
import {
  colorMap,
  colors,
} from "@/components/modules/new-dashboard/components/organizations-by-region/shared";
import { mapGetters } from "vuex";
import OrganizationsByRegionLabels from "@/components/modules/new-dashboard/components/organizations-by-region/organizations-by-region-labels.vue";
import DonutChart from "@/shared/charts/donut-chart/donut-chart.vue";
import DashboardSpinner from "@/components/modules/new-dashboard/components/dashboard-spinner.vue";
import DashboardNoData from "@/components/modules/new-dashboard/components/dashboard-no-data.vue";

export default {
  name: "OrganizationsByRegionWidget",
  components: {DashboardNoData, DashboardSpinner, DonutChart, OrganizationsByRegionLabels },
  data: function () {
    return {
      formattedRegions: [],
      formattedCountries: [],
      colorMap,
      colors,
    };
  },
  watch: {
    getOrganizationsByCountry: {
      handler: function () {
        this.formatCountries();
        this.formatRegions();
      },
      deep: true,
    },
    getSelectedRegionInWidget: {
      handler: function () {
        this.formatCountries();
        this.formatRegions();
      },
      deep: true,
    },
    getOrganizationsByRegion: {
      handler: function () {
        this.formatCountries();
        this.formatRegions();
      },
      deep: true,
    },
  },
  mounted() {
    this.formatCountries();
    this.formatRegions();
  },
  computed: {
    ...mapGetters([
      "getOrganizationsByCountry",
      "getSelectedRegionInWidget",
      "getOrganizationsByRegion",
    ]),
  },
  methods: {
    formatRegions: function () {
      var totals = this.getOrganizationsByRegion.data.reduce(
        (previousValue, currentValue) => previousValue + +currentValue.count,
        0
      );

      var regions = {};

      this.getOrganizationsByRegion.data.forEach((region) => {
        var key = region._id?.region?._id ?? 'Sin Region'
        if (typeof regions[key] === "undefined") {
          regions[key] = {
            id: key,
            name: this.$t(region._id?.region?.region ?? 'Sin Region'),
            value: 0,
            percentage: "0",
            originalName: region._id?.region?.region ?? 'Sin Region',
          };
        }
        regions[key].value += +region.count;
        regions[key].percentage = (
          100 *
          (regions[key].value / totals)
        ).toFixed(0);
      });

      this.formattedRegions = Object.values(regions).sort((a, b) => a.name.localeCompare(b.name));
    },

    formatCountries: function () {
      if (!this.getSelectedRegionInWidget) {
        return [];
      }

      var countriesForRegion = this.getOrganizationsByRegion.data.filter(
        (region) => {
          var key = region._id?.region?._id ?? 'Sin Region'
          return key  === this.getSelectedRegionInWidget
        }
      );
      var totals = countriesForRegion.reduce(
        (previousValue, currentValue) => previousValue + +currentValue.count,
        0
      );

      this.formattedCountries = countriesForRegion.map((country) => {
        return {
          id: country._id.country._id,
          value: country.count,
          name: this.$t(country._id.country.country),
          originalName: country._id.country.country,
          percentage: (100 * (country.count / totals)).toFixed(0),
        };
      }).sort((a, b) => a.name.localeCompare(b.name));
    },
    onSelectRegion: function (regionId) {
      this.$store.commit("setSelectedRegionInWidget", regionId);
    },
    onSelectCountry: function () {
      this.$store.commit("setSelectedRegionInWidget", null);
    },
  },
};
</script>

<template>
  <div style="height: 100%">
      <dashboard-spinner :height="221" v-if="getOrganizationsByRegion.loading" ></dashboard-spinner>
      <dashboard-no-data v-if="!formattedRegions.length && !getOrganizationsByRegion.loading"></dashboard-no-data>

    <div
      v-if="formattedRegions.length && !getOrganizationsByRegion.loading"
      class="public-institutions-by-area"
      style="cursor: pointer"
    >
      <div
        v-if="!getSelectedRegionInWidget"
        class="public-institutions-by-region"
        :style="{ opacity: getSelectedRegionInWidget ? '0' : '1' }"
      >
        <donut-chart
          :color-map="colorMap"
          :colors="colors"
          :chart-data="formattedRegions"
          :on-select="onSelectRegion"
          :parent-size="false"
          :size="221"
        />
        <organizations-by-region-labels
          :colors="colors"
          :chart-data="formattedRegions"
          :on-select-region="onSelectRegion"
        />
      </div>
      <div
        v-if="formattedCountries.length && getSelectedRegionInWidget"
        class="public-institutions-by-region public-institutions-by-country"
        :style="{ opacity: getSelectedRegionInWidget ? '1' : '0' }"
      >
        <donut-chart
          :colors="colors"
          :chart-data="formattedCountries"
          :on-select="onSelectCountry"
          :color-map="colorMap"
          :parent-size="false"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.public-institutions-by-region {
  display: flex;
}

.public-institutions-by-area {
  position: relative;
  top: -10px;
}

.public-institutions-by-country {
  position: absolute;
  top: 0;
  left: 0;
}

.loading {
  height: 236px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<style lang="scss">
.public-institutions-by-area-modal-container {
  height: 100%;

  .public-institutions-by-region,
  .public-institutions-by-country {
    height: 100%;
    width: 100%;
    align-items: center;
  }

  .donut-chart-svg {
    min-width: 100px;
    height: 100%;
  }

  .region-labels-container {
    height: 100%;
    align-items: center;

    .region-label-container {
      .region-label-name {
        font-size: 1.5vw !important;
        min-width: 12vw !important;
        max-width: 12vw !important;
        flex-basis: 15vw !important;
      }

      .region-label-value {
        font-size: 1.5vw !important;
        min-width: 5vw !important;
        max-width: 5vw !important;
        flex-basis: 15vw !important;
      }

      .region-label-color {
        width: 1.5vw !important;
        height: 1.5vw !important;
      }
    }
  }
}
</style>
